// @core/api/endpoints/tag/search_tags.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTagsResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Search tags
 * Searches tags by name prefix for autocomplete. Returns matching tags sorted by usage count (most popular first). Automatically filtered by actor visibility rules.
 */
export async function SearchTags(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    product_id?: string | number | boolean;
    q?: string | number | boolean;
    sort?: string | number | boolean;
    visibility?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTagsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags/search`;
  const requestOptions = options;
  return client.get<ListTagsResponse>(requestPath, { ...requestOptions, params });
}
